import VueClickAway from 'vue3-click-away';
import app from '@/app';

// Makes 'v-click-away' directive usable in every component
app.use(VueClickAway);
